import {
  getData,
  postData,
  convertPageModel
} from './api-base.service'

export const createBonusPointExchangeItemModel = () => {
  let model = {
    Id: 0,
    Enable: true,
    ItemName: "",
    BonusPoint: 0,
    EnableText: "启用"
  };

  return model;
}

export const getBonusPointMechanismByType = (type) => {
  let data = {
    type: type
  };

  let fetchResult = getData('/Common/GetBonusPointMechanismByType', data);

  return fetchResult;
}

export const getBonusPointMechanismListByTypes = (types) => {
  let data = types;

  let fetchResult = postData('/Common/GetBonusPointMechanismListByTypes', data);

  return fetchResult;
}

export const saveBonusPointMechanism = (model) => {
  let data = model;

  let fetchResult = postData('/BonusPoint/SaveBonusPointMechanism', data);

  return fetchResult;
}

export const getBonusPointExchangeItemList = () => {
  let fetchResult = getData('/BonusPoint/GetBonusPointExchangeItemList');

  return fetchResult;
}

export const getBonusPointExchangeItemsPageData = (model) => {
  let data = convertPageModel(model);

  var fetchResult = postData('/BonusPoint/GetBonusPointExchangeItemsPageData', data);

  return fetchResult;
}

export const saveBonusPointExchangeItem = (model) => {
  let data = model;

  let fetchResult = postData('/BonusPoint/SaveBonusPointExchangeItem', data);

  return fetchResult;
}



// WEBPACK FOOTER //
// ./src/service/bonusPoint.service.js